const TaskStructure = [
  {
    id: 1,
    name: 'Hello, world! 2',
    description: 'Sekuel dari "Hello, world!"',
    difficulty: 1,
    xp: 5,
  },
  {
    id: 2,
    name: 'Faktorisasi Prima',
    description: 'Menjabarkan faktorisasi prima dari sebuah bilangan',
    difficulty: 3,
    xp: 25,
  },
  {
    id: 3,
    name: 'Soal Gampang',
    description: 'Kamu bakal kecewa kalo gagal soal ini',
    difficulty: 1,
    xp: 1,
  },
  {
    id: 4,
    name: 'Lorem Ipsum',
    description: 'Lorem ipsum dolor sit amet',
    difficulty: 1,
    xp: 1,
  },
  {
    id: 5,
    name: 'Lorem Ipsum',
    description: 'Lorem ipsum dolor sit amet',
    difficulty: 1,
    xp: 2,
  },
  {
    id: 6,
    name: 'Lorem Ipsum',
    description: 'Lorem ipsum dolor sit amet',
    difficulty: 1,
    xp: 1,
  },
  {
    id: 7,
    name: 'Lorem Ipsum',
    description: 'Lorem ipsum dolor sit amet',
    difficulty: 1,
    xp: 3,
  },
  {
    id: 8,
    name: 'Lorem Ipsum',
    description: 'Lorem ipsum dolor sit amet',
    difficulty: 1,
    xp: 2,
  },
  {
    id: 9,
    name: 'Lorem Ipsum',
    description: 'Lorem ipsum dolor sit amet',
    difficulty: 1,
    xp: 1,
  },
  {
    id: 10,
    name: 'Lorem Ipsum',
    description: 'Lorem ipsum dolor sit amet',
    difficulty: 1,
    xp: 3,
  },
]

export default TaskStructure
